import cloudStorage from "../img/projects/cloudStorage.png";
import realcoffeeshop from "../img/projects/coffee.png";
import djangoPortfolio from "../img/projects/django.png";
import diabetesPrediction from "../img/projects/ml.png";
import reactPortfolio from "../img/projects/portfolio2023.png";

export const projects = [
  {
    thumbnail: cloudStorage,
    title: "Implementation Of STaaS using Cloud NAS",
    desc: "Full-Stack Cloud storage platform where users can upload files to cloud and retrieve files from the cloud",
    live: "https://cloudstorageplatform.netlify.app/",
    github: "https://github.com/Jaividyasagar/cloudStorageWebApp",
  },
  {
    thumbnail: reactPortfolio,
    title: "Professional Portfolio 2023",
    desc: "A professional portfolio site which gives informations about me, my skills, certifications, services providing, qualifications and contact information",
    live: "https://jaividyasagar.netlify.app/",
    github: "https://github.com/Jaividyasagar/react-portfolio",
  },
  {
    thumbnail: diabetesPrediction,
    title: "Diabetes Prediction using Machine Learning Techniques",
    desc: "Full-Stack site where users can get to know whether they have diabetes or not",
    live: "https://mldiabetespredictor.pythonanywhere.com/",
    github:
      "https://github.com/Jaividyasagar/diabetes-prediction-machine-learning",
  },
  {
    thumbnail: djangoPortfolio,
    title: "Personal Portfolio",
    desc: "Django based portfolio site where anyone can know about me and my contact information",
    live: "https://jaividyasagar.pythonanywhere.com/",
    github: "https://github.com/Jaividyasagar/django3-personal-portfolio",
  },
  {
    thumbnail: realcoffeeshop,
    title: "The Real Coffee Shop",
    desc: "A coffee shop site where users can see the coffees available and can order them",
    live: "https://jaividyasagar.github.io/Coffee-Shop-site/",
    github: "https://github.com/Jaividyasagar/Coffee-Shop-site",
  },
];
